import { useState } from "react";
import { Badge, Button, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import print from "../../../Enums/Print";
import Pagination from "../Pagination/Pagination";
import { ExportExcel } from "../../../Enums/Export";
import ReportsService from "../../../../services/ReportsService";
import Select from "react-select";

const SubscriptionReports = () => {
	const [data, setData] = useState([]);
	const [status, setStatus] = useState("");
	const [subscriptionType, setSubscriptionType] = useState("");
	const [hasData, setHasData] = useState(null);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const [params, setParams] = useState({});
	const lang = useSelector((state) => state.auth?.lang);
	const reportsService = new ReportsService();
	const search = useSelector((state) => state.auth.search);
	const subscriptionTypeOptions = [
		{ label: Translate[lang].monthly, value: "monthly" },
		{ label: Translate[lang].annually, value: "annually" },
	];
	const options = [
		{ label: Translate[lang].expired, value: "expired" },
		{ label: Translate[lang].active, value: "active" },
	];

	const printPage = () => {
		let headRow = [
			Translate[lang].user,
			Translate[lang].phone,
			Translate[lang].package_name,
			Translate[lang].subscription_type,
			Translate[lang].expiry_date,
			Translate[lang].status,
		];
		let dataInfo = data?.map((res) => {
			let info = {
				user: res?.fullname,
				phone: res?.phone,
				package_name: res?.package[`name_${lang}`],
				subscription_type: res?.subscription_type,
				expiry_date: res?.subscriptionExpirationDate?.split("T")[0],
				status: res?.status,
			};
			return info;
		});
		print("Users", headRow, lang, dataInfo);
	};

	const applyFilter = () => {
		let paramsUpdate = {};
		if (!!status) paramsUpdate["status"] = status?.value;
		if (!!subscriptionType)
			paramsUpdate["subscription_type"] = subscriptionType?.value;
		setParams(paramsUpdate);
		setShouldUpdate((prev) => !prev);
	};

	return (
		<>
			<div className="d-flex justify-content-between mb-4 align-items-center">
				<span
					style={{
						fontWeight: "600",
						textTransform: "capitalize",
						color: "#000",
					}}>
					{Translate[lang].subscription_reports}
				</span>
				<div className="d-flex gap-8">
					<Button
						variant="outline-primary"
						onClick={() => ExportExcel(data, "subscription-reports")}>
						<i className="las la-download fs-20" /> {Translate[lang].export}
					</Button>
					<Button variant="primary" onClick={() => printPage()}>
						<i className="las la-print fs-20" /> {Translate[lang].print}
					</Button>
				</div>
			</div>
			<div class="accordion " id="accordionExample">
				<div class="accordion-item border-shadow p-0">
					<h2 class="accordion-header" id="headingOne">
						<button
							class="accordion-button fw-bold"
							type="button"
							style={{
								fontSize: "18px",
								background: "none",
								boxShadow: "none",
								color: "#000",
							}}
							data-bs-toggle="collapse"
							data-bs-target="#collapseOne"
							aria-expanded="true"
							aria-controls="collapseOne">
							{Translate[lang].filter}
						</button>
					</h2>
					<div
						id="collapseOne"
						class="accordion-collapse collapse show"
						aria-labelledby="headingOne"
						data-bs-parent="#accordionExample">
						<div class="accordion-body px-0">
							<div className="row w-100 m-auto">
								<div className="col-4">
									<label>{Translate[lang].subscription_type}</label>
									<Select
										options={subscriptionTypeOptions}
										value={subscriptionType}
										onChange={(e) => setSubscriptionType(e)}
									/>
								</div>
								<div className="col-4">
									<label>{Translate[lang].status}</label>
									<Select
										options={options}
										value={status}
										onChange={(e) => setStatus(e)}
									/>
								</div>
								<div className={!!status ? "col-4" : "col-2"}>
									<div className="d-flex h-100 gap-8 align-items-end">
										<Button
											variant="outline-primary"
											className="w-100"
											onClick={applyFilter}>
											{Translate[lang].apply}
										</Button>
										{!!status && (
											<Button
												variant="outline-danger"
												className="w-100"
												onClick={() => {
													setStatus("");
													setSubscriptionType("");
													setParams({});
													setShouldUpdate((prev) => !prev);
												}}>
												{Translate[lang].clear_filter}
											</Button>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="mt-4">
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr className="text-center">
									<th>
										<strong>{Translate[lang].user}</strong>
									</th>
									<th>
										<strong>{Translate[lang].phone}</strong>
									</th>
									<th>
										<strong>{Translate[lang].package_name}</strong>
									</th>
									{/* <th>
										<strong>{Translate[lang].type}</strong>
									</th> */}
									<th>
										<strong>{Translate[lang].subscription_type}</strong>
									</th>
									<th>
										<strong>{Translate[lang].expiry_date}</strong>
									</th>
									<th>
										<strong>{Translate[lang].status}</strong>
									</th>
								</tr>
							</thead>

							<tbody className="table-body">
								{data?.map((item, index) => {
									return (
										<tr key={index} className="text-center">
											<td className="text-wrap-mode">{item.fullname}</td>
											<td className="text-wrap-mode">{item.phone}</td>
											<td>{item?.package[`name_${lang}`]}</td>
											{/* <td>{"-"}</td> */}
											<td>{item?.subscription_type}</td>
											<td>{item?.subscriptionExpirationDate?.split("T")[0]}</td>
											<td>
												<Badge
													className="text-capitalize cursor-pointer"
													variant={`${
														item?.status === "active" ? "success" : "danger"
													} light`}>
													{
														Translate[lang][
															item?.status === "active" ? "active" : "deactive"
														]
													}
												</Badge>
											</td>
										</tr>
									);
								})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && !loading && <NoData />}
					<Pagination
						setData={setData}
						service={reportsService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
						type="subscription"
						param={params}
					/>
				</div>
			</div>
		</>
	);
};

export default SubscriptionReports;
